import React from 'react';
import PropTypes from 'prop-types';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import { CHILDREN_PROP_TYPES } from 'propTypes';

import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import MenuItemNameTypography from 'components/MenuItemNameTypography';
import {
  ITEM_DESCRIPTION_AND_PRICES,
  MENU_ITEM_NAMES
} from 'styles/constants/appearanceSectionNames';
import RequiredChip from 'components/RequiredChip';

const VariantFieldSet = ({ title, required, children, helperText }) => {
  const headerStyles = { variant: MENU_ITEM_NAMES };

  const helperStyles = { variant: ITEM_DESCRIPTION_AND_PRICES };

  return (
    <FormControl component="fieldset">
      <Box mb={1}>
        <FormLabel>
          <Box display="flex" alignItems="center">
            <MenuItemNameTypography
              component="span"
              fontSize="16px"
              {...headerStyles}
            >
              {title}
            </MenuItemNameTypography>
            {required && <RequiredChip label="Required" size="small" />}
          </Box>
          {helperText && (
            <Box mt={1}>
              <MenuItemDescriptionTypography {...helperStyles}>
                {helperText}
              </MenuItemDescriptionTypography>
            </Box>
          )}
        </FormLabel>
      </Box>

      {children}
    </FormControl>
  );
};

VariantFieldSet.propTypes = {
  title: PropTypes.string,
  required: PropTypes.bool,
  helperText: PropTypes.string,
  children: CHILDREN_PROP_TYPES
};

export default VariantFieldSet;
